import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75d40448"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-footer__certificates" }


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooterCertificates',
  setup(__props) {

const zertifikatCO2 = `${window.ioappConfig.themeUri}/public/img/Zertifikat-co2neutralwebsite.svg`;
const regionalVersorger = `${window.ioappConfig.themeUri}/public/img/DeutschlandsbesteRegionalversorger2024HerausragendStromundGas.png`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("img", {
        class: "app-footer__certificates--co2",
        src: zertifikatCO2,
        alt: "zertifikatCO2"
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("img", {
        class: "app-footer__certificates--regionalversorger",
        src: regionalVersorger,
        alt: "Deutschlands beste Regionalversorger 2024 - Herausragend Strom und Gas"
      })
    ])
  ]))
}
}

})